export interface IEventPayload {
    /**
     * @member id Unique identifier of object that emitted event
     */
    id: string
    /**
     * @member metadata The additional data that you can provide in Editor on web site for each block
     */
    metadata: string
}

export declare type Event = string

export class BlockEvent<EventPayload extends IEventPayload> {
    public readonly name: Event

    constructor(name: Event) {
        this.name = name
    }

    getPayload = (eventPayload: any): EventPayload => {
        return eventPayload
    }
}
